/**
 * Responsibility: say plainly when the processor is unreachable, and what still
 * works.
 *
 * **The point of the split made visible.** Everything a person typed lives in
 * Firebase and is readable without the Oracle box; everything the box computes
 * - search, the discovery and catalogue boards, prices, news - is not. Without
 * a banner those two failures look identical: some pages work, some are empty,
 * and nobody can tell whether their data is gone.
 *
 * It says what is still true rather than only what is broken, because "your
 * collection is safe" is the thing somebody actually wants to know when a page
 * they expected has nothing on it.
 *
 * The probe itself lives in `useHubOnline`, split out because a module that
 * exports both a hook and a component breaks fast refresh.
 */

import CloudOffIcon from '@mui/icons-material/CloudOff';
import { Alert, AlertTitle, Collapse } from '@mui/material';
import { useHubOnline } from './useHubOnline';

export function AnalysisOfflineBanner() {
  const { online, checked } = useHubOnline();
  const show = checked && !online;

  return (
    <Collapse in={show} unmountOnExit>
      <Alert severity="warning" icon={<CloudOffIcon />} sx={{ mb: 2 }}>
        <AlertTitle>Analysis is offline</AlertTitle>
        Your collection, likes, saved searches and settings are stored in Firebase
        and are safe - you are reading them now. Search, the discovery and
        catalogue boards, live prices and news need the processor, and will come
        back on their own when it does. Changes are paused until then.
      </Alert>
    </Collapse>
  );
}
